export default __webpack_public_path__ + "static/media/folder.1c438262.png";